export const HANDRAISER_NAME_SRP = 'search-comparison';
// TODO: get real handraiser names whenever these become dynamic
export const HANDRAISER_NAME_PURCHASE = 'purchase';
export const HANDRAISER_NAME_STC = 'stc';
